import { Skeleton } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

import { HeaderHomeContainer } from './HeaderHomeContainer'

export const HeaderHomeLoading: FC = () => {
  return (
    <HeaderHomeContainer>
      <Skeleton width={unit(30)} height={unit(10.5)} sx={{ bgcolor: COLORS.white, marginBottom: unit(2.5) }} />
      <Skeleton width={unit(50)} height={unit(7.5)} sx={{ bgcolor: COLORS.white, marginBottom: unit(2.5) }} />
      <Skeleton width={unit(60)} height={unit(6)} sx={{ bgcolor: COLORS.white, marginBottom: unit(2.5) }} />
      <Skeleton width={'100%'} height={unit(20)} sx={{ bgcolor: COLORS.white }} />
    </HeaderHomeContainer>
  )
}
